import api from "../api";
import {createNamespacedHelpers} from "vuex";

const {mapState} = createNamespacedHelpers('journeyBuilder/composer');

let _isLocked;

export default {
    async created(){
        const vm = this;
        
        await this.$store.dispatch('journeyBuilder/composer/loadPermissions');
        
        api.validateDeletePermission()
            .then(
                () => vm.hasDeletePermission = true,
                () => vm.hasDeletePermission = false
            );

        api.validateActivationPermission()
            .then(
                () => vm.hasActivationPermission = true,
                () => vm.hasActivationPermission = false
            );
    }, 
    methods: {
        $_setLockedState(isLocked){
            _isLocked = isLocked;
            
            //_isLocked is 'global' and thus not reactive
            this.$forceUpdate();
        }
    },
    computed: {
        ...mapState(['hasWritePermission']),
        hasSpecialWritePermission(){
            //Treat both the same for the time being
            return this.hasWritePermission;
        },
        canWrite(){
            const vm = this;
            
            //Special write permission is always allowed to write, lock, and unlock
            return vm.hasSpecialWritePermission || (!_isLocked && vm.hasWritePermission);
        },
        isLocked: {
            get() {
                return _isLocked;
            }
        }
    },
    data: function(){
        return {
            //Our privates should NOT be prefixed with $_; this seems to tell Vue to make them not reactive(?)
            
            //Initialise values with NULL to ensure our watch functions get triggered
            //when the actual value is set
            hasActivationPermission: null,
            hasDeletePermission: null
        };
    }
};